import styles from './language-switch.module.scss';
import Uk from '@/assets/icons/uk-icon.svg?react';
import Icon from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface LanguagesSwitchProps {
  /** Controlled. Internal state seeded once desynced whenever the owner remounted, which
   *  a drawer does far more often than the route it replaced. */
  active: 'original' | 'english';
  onSwitch: (translate: string) => void;
  flagUrl: string;
}

export default function LanguagesSwitch({ active, onSwitch, flagUrl }: LanguagesSwitchProps) {
  const { t } = useTranslation('settings');

  const handleSwitch = (type: 'original' | 'english') => {
    onSwitch(type === 'english' ? 'true' : 'false');
  };

  return (
    <div className={styles.switchContainer}>
      <button
        type="button"
        aria-label={t('languageSwitch.showEnglish')}
        aria-pressed={active === 'english'}
        className={`${styles.switchButton} ${active === 'english' ? styles.active : styles.inactive}`}
        onClick={() => handleSwitch('english')}
      >
        <Icon
          className={`${styles.flag} ${active === 'english' ? styles.active : styles.inactive}`}
          component={() => <Uk width="20" height="20" />}
        />
      </button>
      <button
        type="button"
        aria-label={t('languageSwitch.showOriginal')}
        aria-pressed={active === 'original'}
        className={`${styles.switchButton} ${active === 'original' ? styles.active : styles.inactive}`}
        onClick={() => handleSwitch('original')}
      >
        <div className={styles.flagContainer}>
        <img
          src={flagUrl}
          alt={t('languageSwitch.originalFlagAlt')}
          width="20"
          height="20"
          className={`${styles.flag} ${active === 'original' ? styles.active : styles.inactive}`}
        />
        </div>
      </button>
    </div>
  );
}
